<template>
  <div class="create-job-wrapper">
    <div class="create-job">
      <div class="row">
        <div class="input-wrapper">
          <input type="text" v-model="job.position" placeholder="Позиция, за която се кандидатства" />
        </div>
      </div>
      <div class="row">
        <div class="select-wrapper">
          <select v-model="job.company" required>
            <option value selected disabled>Дружество от ХОЛДИНГ КЦМ 2000, в което се кандидатства</option>
            <option value="ХОЛДИНГ КЦМ 2000 АД">ХОЛДИНГ КЦМ 2000 АД</option>
            <option value="КЦМ АД">КЦМ АД</option>
            <option value="КЦМ Трейд ЕООД">КЦМ Трейд ЕООД</option>
            <option value="КЦМ Технолоджи ЕООД">КЦМ Технолоджи ЕООД</option>
            <option val ue="Комплексен индустриален сервиз ЕООД">Комплексен индустриален сервиз ЕООД</option>
            <option value="Металургремонт 21 EАД">Металургремонт 21 EАД</option>
            <option value="Стопански дейности КЦМ ЕООД">Стопански дейности КЦМ ЕООД</option>
            <option value="Стройсервиз ЕООД">Стройсервиз ЕООД</option>
            <option value="Индустриална зона КЦМ ЕООД">Индустриална зона КЦМ ЕООД</option>
            <option value="Лъки Инвест АД">Лъки Инвест АД</option>
            <option value="Върба-Батанци АД">Върба-Батанци АД</option>
            <option value="BLZ Metalikon Ltd">BLZ Metalikon Ltd</option>
            <option value="MCM BV">MCM BV</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="textarea-wrapper">
          <textarea cols="30" rows="10" v-model="job.content" placeholder="Съдържание (html)"></textarea>
        </div>
      </div>
      <div class="row">
        <a class="link" v-if="!$route.params.id" @click="submit">
          <span class="text-main">СЪЗДАЙ</span>
        </a>
        <template v-else>
          <a class="link" @click="update">
            <span class="text-main">РЕДАКТИРАЙ</span>
          </a>
          <a class="link" @click="deleteJob">
            <span class="text-main">ИЗТРИЙ</span>
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      job: {
        position: '',
        company: '',
        content: ''
      }
    };
  },
  watch: {
    $route() {
      this.getJob();
    }
  },
  methods: {
    getJob() {
      let url = `${process.env.VUE_APP_BASE_URI}/jobs/${this.$route.params.id}`;

      this.$http
        .get(url)
        .then(result => {
          this.job = result.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    submit() {
      if (this.isValid()) {
        let url = `${process.env.VUE_APP_BASE_URI}/jobs`;

        this.$http
          .post(url, this.job)
          .then(() => {
            this.$snotify.success('Обявата е качена успешно!');

            this.job = {
              position: '',
              company: '',
              content: ''
            };
          })
          .catch(err => {
            console.log(err);
            this.$snotify.error('Нещо се обърка, моля опитайте отново.');
          });
      }
    },
    update() {
      if (this.isValid()) {
        let url = `${process.env.VUE_APP_BASE_URI}/jobs/${this.$route.params.id}`;

        this.$http
          .put(url, this.job)
          .then(() => {
            this.$snotify.success('Обявата е редактирана успешно!');

            this.getJob();
          })
          .catch(err => {
            console.log(err);
            this.$snotify.error('Нещо се обърка, моля опитайте отново.');
          });
      }
    },
    deleteJob() {
      let url = `${process.env.VUE_APP_BASE_URI}/jobs/${this.$route.params.id}`;

      this.$http
        .delete(url)
        .then(() => {
          this.$snotify.success('Обявата е изтрита успешно!');

          this.$router.push('/administration/job');

          this.job = {
            position: '',
            company: '',
            content: ''
          };
        })
        .catch(err => {
          console.log(err);
          this.$snotify.error('Нещо се обърка, моля опитайте отново.');
        });
    },
    isValid() {
      if (!this.job.position) {
        this.$snotify.error('Не сте попълнили позиция!');
        return false;
      }
      if (!this.job.company) {
        this.$snotify.error('Не сте избрали дружество!');
        return false;
      }
      if (!this.job.content) {
        this.$snotify.error('Не сте добавили съдържание!');
        return false;
      }
      return true;
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.getJob();
    }
  }
};
</script>

<style lang="scss" scoped>
.create-job-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
}
.create-job {
  display: flex;
  flex-direction: column;
  width: 500px;
  .row {
    margin-bottom: 10px;
    .textarea-wrapper {
      height: initial;
    }
    textarea {
      display: block;
      padding-top: 10px;
    }
    &:last-of-type {
      justify-content: center;
      padding-top: 10px;
      .link {
        color: #22075e;
        &:last-of-type {
          margin-left: 10px;
        }
      }
      .link::before {
        background-color: $accentColor;
      }
    }
  }
}
</style>